import { defineComponent as _defineComponent } from 'vue'
import { landingFormSuccessWaitlistData } from "@/constants/landingData";
  import { useIsDesktop } from "@/features/useIsDesktop";

  const MIN_DESKTOP_WIDTH = 992;
  
export default /*@__PURE__*/_defineComponent({
  __name: 'LandingSuccessForm',
  props: {
    textData: {}
  },
  emits: ["signIn"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const { isDesktop } = useIsDesktop(MIN_DESKTOP_WIDTH);
  const emit = __emit;

  const props = __props;

  const onSingIn = () => emit("signIn");

const __returned__ = { MIN_DESKTOP_WIDTH, isDesktop, emit, props, onSingIn, get landingFormSuccessWaitlistData() { return landingFormSuccessWaitlistData }, get useIsDesktop() { return useIsDesktop } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})